import React, { FunctionComponent, useEffect } from 'react';
import { getList } from '@stores/push';
import PushTable from '@components/PushTable';
import PushEditModal from '@components/PushEditModal';
import PushListHeader from '@components/PushListHeader';

interface PushListRouteProps {}

const PushListRoute: FunctionComponent<PushListRouteProps> = () => {
  useEffect(() => {
    getList();
  }, []);
  return (
    <>
      <PushListHeader />
      <PushTable />
      <PushEditModal />
    </>
  );
};

export default PushListRoute;
